<template>
<el-form ref="editForm" size="small" label-width="100px" :model="editJson" :rules="rules">
  <el-form-item label="菜单编号" prop="MENU_ID">
    <el-input v-model="editJson.MENU_ID"></el-input>
  </el-form-item>
  <el-form-item label="菜单名称" prop="MENU_NAME">
    <el-input v-model="editJson.MENU_NAME"></el-input>
  </el-form-item>
  <el-form-item label="菜单URL" prop="MENU_URL">
    <el-input v-model="editJson.MENU_URL" @change="UrlChange"></el-input>
  </el-form-item>
  <el-form-item label="父菜单编号" prop="PARENT_MENU_ID">
    <common-select v-model="editJson.PARENT_MENU_ID" :url="$api.sys.menu.list" :filterData="(res)=>([rootMenu].concat(res.data.Rows))" optLabel="MENU_NAME" optValue="MENU_ID"></common-select>
  </el-form-item>
  <el-form-item label="菜单分组" prop="MENU_GROUP">
    <el-input v-model="editJson.MENU_GROUP"></el-input>
  </el-form-item>
  <el-form-item label="排序" prop="SORT">
    <el-input-number v-model="editJson.SORT" step="1" min="0" max="999" step-strictly></el-input-number>
  </el-form-item>
  <el-form-item label-width="0" class="atb-no-margin">
    <div class="atb-text-right">
      <!-- 保存 -->
      <el-button type="primary" @click="submit">保存</el-button>
      <!-- 取消 -->
      <el-button type="info" @click="cancel">取消</el-button>
    </div>
  </el-form-item>
</el-form>
</template>

<script>
import editMixin from '@/mixins/edit.mixin'
export default {
  mixins: [editMixin],
  props: {
    parentId: String,
    autoMenuId: String
  },
  data() {
    return {
      id: 'ID',
      rules: {},
      addApi: this.$api.sys.menu.add,
      editApi: this.$api.sys.menu.update,
      rootMenu: { MENU_ID: '00', MENU_NAME: '根菜单' },
      YesOrNo: [
        { label: '是', value: 1 },
        { label: '否', value: 0 }
      ]
    }
  },
  mounted() {
    if (!this.isEdit) {
      this.$set(this.editJson, 'PARENT_MENU_ID', this.parentId)
      this.$set(this.editJson, 'MENU_ID', this.autoMenuId)
      this.$set(this.editJson, 'SORT', parseInt(this.autoMenuId.replace(this.parentId, '')))
      this.cacheEditJson = JSON.parse(JSON.stringify(this.editJson))
    }
  },
  methods: {
    UrlChange() {
      let url_value = (this.editJson.Url || '').replace(/\//g, '-').replace(/^-/, '')
      this.$set(this.editJson, 'REMARKS', url_value)
    }
  }
}
</script>
